import { FC, ReactNode } from 'react'
import ExternalLayout from 'components/features/external/ExternalLayout/ExternalLayout'
import styles from 'components/features/coaching/advisorPublicPage/AdvisorPublicPagePreset/AdvisorPublicPagePreset.styl'
import Button from 'components/features/pfm/Button/Button'
import { ModulePreset } from 'components/features/coaching/advisorPublicPage/ModulePreset/ModulePreset'

type AdvisorPublicPagePresetProps = {
  header: ReactNode
  introduction: ReactNode
  rating: ReactNode
  reviews: ReactNode
  certifications: ReactNode
  onCTA: () => void
}
export const AdvisorPublicPagePreset: FC<AdvisorPublicPagePresetProps> = (props) => {
  const { header, introduction, onCTA, rating, reviews, certifications } = props

  return (
    <div className={ styles.AdvisorPublicPagePreset }>
      <ExternalLayout
        type='advisor'
        isSingleColumn
        noFooter
        contentClassName={ styles.pageHeader }
      />
      <div className={ styles.pageContent }>
        <div className={ styles.header }>
          { header }
        </div>
        <ExternalLayout
          type='advisor'
          noStickyHeader
          headerNode={ null }
          isSingleColumn
        >
          { introduction && (
            <ModulePreset
              title='Introduction'
              className={ styles.introduction }
            >
              { introduction }
            </ModulePreset>
          )}

          <div className={ styles.cta }>
            <Button onClick={ onCTA }>SCHEDULE VIDEO CALL</Button>
          </div>

          { rating }
          { reviews }
          { certifications && (
            <ModulePreset className={ styles.certifications } noCard title='Certifications'>
              { certifications }
            </ModulePreset>
          )}
        </ExternalLayout>
      </div>
    </div>
  )
}
